// children 选项类型枚举
export const ITEM_TYPE = {
    INPUT: 0,
    RADIO: 1,
    CHECKBOX: 2,
    TEXT: 3,
}

// 菜单类型枚举
export const MENU_TYPE = {
    MENU: 0,
    QUESTION: 1,
    OPTION: 2,
}

// 选项选中或未选中的状态枚举
export const CHECK_STATUS = {
    NO_CHECKED: 0,
    CHECKED: 1,
}

// 获取应该更新 state.bodyData '哪一层级' 的 值(value)
export const getKey = (keyList) => {
    const bodyIndex = keyList.shift()
    return `bodyData[${bodyIndex}]${keyList.map((index) => `.children[${index}]`).join('')}.value`
}

// 数据前置处理
export const bodyListBeforeHandle = (bodyList) => {
    // menuType 0 菜单 1 问题 2选项
    // itemType 1单选 2 多选 3 文本
    for (const item of bodyList) {
        const { menuType, itemType, children = [], remark = '' } = item
        if (menuType === MENU_TYPE.MENU) {
            // 本层是菜单的情况下，处理子级即可
            item.children = bodyListBeforeHandle(children)
        } else if (menuType === MENU_TYPE.QUESTION) {
            // 本层是问题的情况下，分几种情况
            if (itemType === ITEM_TYPE.RADIO) {
                // 下层是单选选项的情况，把下层继续去处理
                item.children = bodyListBeforeHandle(children)
                // 从下层选项里 status 被选中的项赋值给 value，否则就赋值 null 表示没有选中
                const checkedItem = item.children.find((item) => item.status)
                item.value = checkedItem ? checkedItem.id : null
            } else if (itemType === ITEM_TYPE.CHECKBOX) {
                // 下层是多选选项的情况，把下层继续去处理
                item.children = bodyListBeforeHandle(children)
                // 从下层选项里 status 被选中的项赋值给 value，因为是多选所以 value 是个数组
                const checkedList = item.children.filter((item) => item.status).map((item) => item.id)
                item.value = checkedList
            } else if (itemType === ITEM_TYPE.TEXT) {
                // 下层是文本的情况，就没有下层了，把本层的 remark 赋值给 value
                item.status = 1
                item.value = remark
            }
        } else if (menuType === MENU_TYPE.OPTION) {
            // 本层是选项的情况下，分情况
            if (item.itemType === ITEM_TYPE.INPUT) {
                // 选项这层的 itemType 是 0 的时候要加个输入框，所以把本层的 remark 赋值给 value
                item.status = 1
                item.value = remark
            }
        }
    }
    return bodyList
}

// 数据后置处理，把 value 都搞到 status 和 remark 上
export const bodyListAfterHandle = (bodyList) => {
    for (const item of bodyList) {
        const { value, menuType, itemType, children = [] } = item
        if (menuType === MENU_TYPE.MENU) {
            // 本层是菜单的情况下，处理子级即可
            item.children = bodyListAfterHandle(children)
        } else if (menuType === MENU_TYPE.QUESTION) {
            // 本层是问题的情况下，分几种情况
            if (itemType === ITEM_TYPE.RADIO) {
                // 下层是单选选项的情况，把下层继续去处理
                item.children = bodyListAfterHandle(children)
                // 单选列表里选中的 status 变为 CHECKED，未选中的变为 NO_CHECKED
                item.children.forEach(
                    (oItem) => (oItem.status = oItem.id === value ? CHECK_STATUS.CHECKED : CHECK_STATUS.NO_CHECKED)
                )
            } else if (itemType === ITEM_TYPE.CHECKBOX) {
                // 下层是多选选项的情况，把下层继续去处理
                item.children = bodyListAfterHandle(children)
                // 多选列表里选中的 status 变为 CHECKED，未选中的变为 NO_CHECKED
                item.children.forEach(
                    (oItem) =>
                        (oItem.status = value.includes(oItem.id) ? CHECK_STATUS.CHECKED : CHECK_STATUS.NO_CHECKED)
                )
            } else if (itemType === ITEM_TYPE.TEXT) {
                // 把本层的 value 赋值给 remark
                item.remark = value
            }
        } else if (menuType === MENU_TYPE.OPTION) {
            // 本层是选项的情况下，分情况
            if (item.itemType === ITEM_TYPE.INPUT) {
                // 把本层的 value 赋值给 remark
                item.remark = value
            }
        }
    }
    return bodyList
}

export const checkCircle = (bodyList) => {
    // menuType 0 菜单 1 问题 2选项
    // itemType 1单选 2 多选 3 文本
    for (const item of bodyList) {
        const { menuType, itemType, children = [], remark = '' } = item
        if (menuType === MENU_TYPE.MENU) {
            // 本层是菜单的情况下，处理子级即可
            item.children = checkCircle(children)
            item.check = item.children.some((oItem) => oItem.check)
        } else if (menuType === MENU_TYPE.QUESTION) {
            // 本层是问题的情况下，分几种情况
            if (itemType === ITEM_TYPE.RADIO) {
                item.check = !!item.value
            } else if (itemType === ITEM_TYPE.CHECKBOX) {
                item.check = Array.isArray(item.value) && item.value.length > 0
            } else if (itemType === ITEM_TYPE.TEXT) {
                item.check = !!item.value
            }
        } else if (menuType === MENU_TYPE.OPTION) {
            // 本层是选项的情况下，分情况
            if (item.itemType === ITEM_TYPE.INPUT) {
                item.check = !!item.value
            }
        }
    }
    return bodyList
}

export const REMAIN_DETAIL_TAB = {
    CARD: 'card', // 卡
    CONSUME: 'consume', // 消费
    COURT: 'court', // 院余
    TICKET: 'ticket', // 券
}
